import { SvgIcon, type SvgIconProps } from '@shared/components';

export default function UserAvatarIcon(props: Readonly<SvgIconProps>) {
  return (
    <SvgIcon
      width='24'
      height='24'
      viewBox='0 0 24 24'
      xmlns='http://www.w3.org/2000/svg'
      stroke='currentColor'
      {...props}
    >
      <circle cx='12' cy='12' r='11' fill='none' strokeWidth='2' />
      <circle cx='7.5' cy='10.75' r='1' />
      <circle cx='16.5' cy='10.75' r='1' />
      <path
        d='M10.2002 16.8C10.2002 16.8 11.1215 17.4 12.0002 17.4C12.8789 17.4 13.8002 16.8 13.8002 16.8'
        strokeWidth='2'
        strokeLinecap='round'
      />
    </SvgIcon>
  );
}
